import { useContext } from 'react';
import { createContext } from 'react';

import { ModalTriggerProps } from '../@types/ModalTriggerProps';

export const ModalTriggerContext = createContext<ModalTriggerProps>({} as ModalTriggerProps);

ModalTriggerContext.displayName = 'ModalTrigger';

const ModalTriggerProvider = (props: ModalTriggerProps) => (
	<ModalTriggerContext.Provider value={props}>{props.children}</ModalTriggerContext.Provider>
);

export const useModalTrigger = () => {
	const context = useContext(ModalTriggerContext);

	return context;
};

export default ModalTriggerProvider;
